export const REPORT_CONFIGURED_FETCH = 'REPORT_CONFIGURED_FETCH';
export const REPORT_STATUS_FETCH = 'REPORT_STATUS_FETCH';
export const REPORT_CREATE_FETCH = 'REPORT_CREATE_FETCH';
export const REPORT_SELECTED = 'REPORT_SELECTED';